<template>
  <div>
        <navbar></navbar>
        <trailer></trailer>
        <buy-it></buy-it>
        <about></about>
        <features></features>
        <pod-gallery></pod-gallery>
        <pod-footer></pod-footer>
  </div>
</template>

<script>
import Vue from 'vue'
import Buy from './components/Buy.vue';
import Navbar from './components/Navbar.vue'
import Trailer from './components/Trailer';
import About from './components/About';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

import "@/assets/nes.css"
import "@/assets/global.css";
import 'video.js/dist/video-js.css';
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

export default {
  name: 'app',
  components: {
    'navbar': Navbar,
    'buy-it': Buy,
    'trailer': Trailer,
    'about': About,
    'features': Features,
    'pod-gallery': Gallery,
    'pod-footer': Footer
  }
}
</script>

<style>
#app {

}

section.body {
  margin-top: 20px;
}
</style>
